import React from "react";
import "./OrganizerTooltip.component.scss";
import telegram from "../../../components/Footer/images/telegram.svg";
import vk from "../../../components/Footer/images/vk.svg";
import odnockasnic from "../../../components/Footer/images/Odnaclas.svg";

interface OrganizerTooltipProps {
    organizer: {
        name: string;
        imageUrl: string;
        description: string;
    };
    position: { top: number; left: number };
}

const OrganizerTooltip: React.FC<OrganizerTooltipProps> = ({ organizer, position }) => {
    return (
        <div className="organizer-tooltip" style={{ top: `${position.top}px`, left: `${position.left}px` }}>
            <img src={organizer.imageUrl} alt={organizer.name} className="tooltip-avatar" />
            <div className="tooltip-content">
                <h3>{organizer.name}</h3>
                <p>{organizer.description}</p>
                <div className="tooltip-icons">
                    <img src={vk} alt="Vk" />
                    <img src={telegram} alt="Telegram" />
                    <img src={odnockasnic} alt="Odnockasnic" />
                    {/* <img src="/icons/web.svg" alt="Website" /> */}
                </div>
            </div>
        </div>
    );
};

export default OrganizerTooltip;
